import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery, useTheme, Dialog, DialogTitle, DialogContent, DialogActions,
  AppBar, Toolbar, IconButton, Drawer, List, ListItemButton, ListItemIcon,
  ListItemText, CssBaseline, Box, Avatar, Menu, MenuItem, Divider,
  Typography, Button, CircularProgress, Grid, Chip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import HistoryIcon from "@mui/icons-material/History";
import LogoutIcon from "@mui/icons-material/Logout";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import SettingsIcon from "@mui/icons-material/Settings";
import LockIcon from "@mui/icons-material/Lock";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import StarIcon from "@mui/icons-material/Star";
import BugReportIcon from "@mui/icons-material/BugReport";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import GroupIcon from "@mui/icons-material/Group";
import { Rating } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import OnboardingModal from "./OnboardingModal";
import PWAInstallBanner from "./PWAInstallBanner";
import GetAppIcon from "@mui/icons-material/GetApp";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const drawerWidth = 300;
const token = () => localStorage.getItem("biyz_token");
const authHead = () => ({ Authorization: `Bearer ${token()}`, "Content-Type": "application/json" });

export default function Layout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(!isMobile);
  const [bots, setBots] = useState([]);
  const [myBotIds, setMyBotIds] = useState(null);
  const [history, setHistory] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [kvkk, setKvkk] = useState(false);
  const [notif, setNotif] = useState(false);
  const [noSubModal, setNoSubModal] = useState(false);
  const [noSubBotName, setNoSubBotName] = useState("");
  const botNameHandled = useRef(false);
  const [helpAnchorEl, setHelpAnchorEl] = useState(null);
  const [rateOpen, setRateOpen] = useState(false);
  const [bugOpen, setBugOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [rateComment, setRateComment] = useState("");
  const [bugText, setBugText] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [me, setMe] = useState(null);
  const [gami, setGami] = useState(null);   // oyunlastirma: seri + XP rozeti
  const [trainersOpen, setTrainersOpen] = useState(false);
  const [pkgs, setPkgs] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const onHome = location.pathname === "/chat" || location.pathname === "/home";

  useEffect(() => {
    fetchMe();
    fetchBots();
    fetchHistory();
    fetchGami();
  }, []);

  // Oyunlastirma rozeti — seri + gunluk XP. Chat cevabindan canli guncellenir.
  const fetchGami = async () => {
    try {
      const res = await fetch("/api/platform/gamification/me", { headers: authHead() });
      if (!res.ok) return;
      setGami(await res.json());
    } catch {}
  };

  // ChatPage cevap dondugunde 'bi-gami' olayi firlatir -> rozet aninda guncellenir
  useEffect(() => {
    const onGami = (e) => { if (e?.detail) setGami((g) => ({ ...(g || {}), ...e.detail })); };
    window.addEventListener("bi-gami", onGami);
    return () => window.removeEventListener("bi-gami", onGami);
  }, []);

  // Davet kodu (kayit sirasinda saklandi) -> giris yapildiginda bir kez uygula
  useEffect(() => {
    const ref = localStorage.getItem("biyz_ref");
    if (!ref) return;
    (async () => {
      try {
        await fetch("/api/platform/gamification/referral/apply", {
          method: "POST", headers: authHead(), body: JSON.stringify({ code: ref }),
        });
      } catch {}
      finally { try { localStorage.removeItem("biyz_ref"); } catch {} }
    })();
  }, []);

  // Profil bayraklarını sunucuya yaz (kvkkAccepted / notifAsked / onboardingDone)
  const putMe = async (fields) => {
    try {
      await fetch("/api/platform/users/me", {
        method: "PUT", headers: authHead(), body: JSON.stringify(fields),
      });
    } catch {}
  };

  // KVKK/bildirim soruları kullanıcı hesabında saklanır — her girişte tekrar sorulmaz
  const fetchMe = async () => {
    try {
      const res = await fetch("/api/platform/users/me", { headers: authHead() });
      if (!res.ok) throw new Error();
      const u = await res.json();
      setMe(u);
      if (u.kvkkAccepted) {
        localStorage.setItem("kvkk_ok", "1");
      } else if (localStorage.getItem("kvkk_ok")) {
        putMe({ kvkkAccepted: true }); // eski localStorage cevabını sunucuya taşı
      } else {
        setKvkk(true);
      }
      if (u.notifAsked) {
        // Seçim sunucuda saklanıyor: reminderOptIn=false ("Hayır") -> "0", aksi -> "1".
        // Böylece TEMİZ tarayıcıda/yeni cihazda da "Hayır" diyene buton bir daha çıkmaz.
        if (!localStorage.getItem("notif_asked")) localStorage.setItem("notif_asked", u.reminderOptIn === false ? "0" : "1");
        // SELF-HEAL: izin verilmis ama abonelik dusmis/hic olusmamis kullaniciyi her giriste sessizce yeniden abone et
        if (localStorage.getItem("notif_asked") === "1" && typeof Notification !== "undefined" && Notification.permission === "granted" && window.biPushSubscribe) window.biPushSubscribe();
      } else if (localStorage.getItem("notif_asked")) {
        putMe({ notifAsked: true });
      } else {
        setNotif(true);
      }
    } catch {
      // Sunucuya ulaşılamazsa eski davranış (localStorage)
      if (!localStorage.getItem("kvkk_ok")) setKvkk(true);
      if (!localStorage.getItem("notif_asked")) setNotif(true);
    }
  };

  useEffect(() => { setOpen(!isMobile); }, [isMobile]);

  const fetchBots = async () => {
    try {
      const [allRes, subRes] = await Promise.all([
        fetch("/api/platform/bots", { headers: authHead() }),
        fetch("/api/subscriptions/me", { headers: authHead() }),
      ]);
      const allBots = await allRes.json();
      const subs = await subRes.json();

      const subItems = Array.isArray(subs?.subscriptions)
        ? subs.subscriptions.filter(s => s?.isActive)
        : (Array.isArray(subs) ? subs.filter(s => s?.isActive) : []);

      const hasGlobal = subItems.some(s => !s.botIds || s.botIds.length === 0);
      const specificBotIds = subItems.flatMap(s => (s.botIds || []).map(id => String(id)));

      setBots((Array.isArray(allBots) ? allBots : []).sort((a, b) => (a.order || 0) - (b.order || 0)));
      setMyBotIds(hasGlobal ? "all" : specificBotIds);
    } catch {
      setBots([]);
      setMyBotIds([]);
    }
  };

  const fetchHistory = async () => {
    try {
      const res = await fetch("/api/platform/chat/my", { headers: authHead() });
      const data = await res.json();
      setHistory(Array.isArray(data) ? data.slice(0, 8) : []);
    } catch { setHistory([]); }
  };

  useEffect(() => {
    if (botNameHandled.current) return;
    if (!bots.length || myBotIds === null) return;
    botNameHandled.current = true;
    const params = new URLSearchParams(window.location.search);
    const botName = params.get("botName");
    if (!botName) return;
    const bot = bots.find(b => b.name.toLowerCase() === botName.toLowerCase());
    if (!bot) return;
    if (myBotIds !== "all" && !myBotIds.includes(String(bot._id))) {
      setNoSubBotName(bot.name);
      setNoSubModal(true);
    } else {
      navigate("/chat", { state: { botId: bot._id, botName: bot.name }, replace: true });
    }
  }, [bots, myBotIds]);

  const handleLogout = () => {
    localStorage.removeItem("biyz_token");
    localStorage.removeItem("biyz_user");
    navigate("/login");
  };
  // PWA kurulum: global yakalanan olay varsa TEK TIK kur; yoksa yonerge penceresi
  const [installInfo, setInstallInfo] = useState(false);
  const handleInstallApp = async () => {
    const p = window.__biDeferredPrompt;
    if (p) { try { p.prompt(); await p.userChoice; } catch {} window.__biDeferredPrompt = null; return; }
    setInstallInfo(true);
  };
  const isStandaloneApp = (() => { try { return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true; } catch { return false; } })();
  // Kuruluysa "Uygulamayı İndir" gizle (kalici hafiza + tarayici raporu + appinstalled)
  const [pwaInstalled, setPwaInstalled] = useState(() => { try { return localStorage.getItem("biyz_pwa_installed") === "1"; } catch { return false; } });
  // Bildirim acildiysa "Bildirimleri Aç" gizle; tarayici reddettiyse de gosterme
  const [pushOn, setPushOn] = useState(() => { try { return (typeof Notification !== "undefined" && Notification.permission === "granted") || localStorage.getItem("biyz_push_on") === "1"; } catch { return false; } });
  const notifDenied = typeof Notification !== "undefined" && Notification.permission === "denied";
  useEffect(() => {
    let alive = true;
    try {
      if (navigator.getInstalledRelatedApps) navigator.getInstalledRelatedApps().then(apps => {
        if (alive && apps && apps.length) { const already = localStorage.getItem("biyz_pwa_installed") === "1"; try { localStorage.setItem("biyz_pwa_installed", "1"); } catch {} if (!already) setTimeout(() => window.location.reload(), 150); else setPwaInstalled(true); }
      }).catch(() => {});
    } catch {}
    const openInfo = () => setInstallInfo(true);
    const onInstalled = () => { try { localStorage.setItem("biyz_pwa_installed", "1"); } catch {} setTimeout(() => window.location.reload(), 150); };
    window.addEventListener("biyz-open-install-info", openInfo);
    window.addEventListener("appinstalled", onInstalled);
    return () => { alive = false; window.removeEventListener("biyz-open-install-info", openInfo); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  const handleEnablePush = async () => {
    try { localStorage.setItem("notif_asked", "1"); } catch {}
    putMe({ notifAsked: true, reminderOptIn: true });
    try {
      if (typeof Notification !== "undefined") {
        const perm = await Notification.requestPermission(); // kullanici jesti icinde ILK is: izin
        if (perm !== "granted") { alert("Tarayıcı bildirim izni vermedi. Gizli (InPrivate) pencerede bildirimler kapalıdır — normal pencerede tekrar deneyin."); return; }
      }
      const ok = window.biPushSubscribe ? await window.biPushSubscribe() : false;
      if (!ok) { alert("Bildirim aboneliği tamamlanamadı. Sayfayı yenileyip tekrar deneyin (gizli pencerede bildirimler kapalıdır)."); return; }
      try { localStorage.setItem("biyz_push_on", "1"); } catch {}
      setPushOn(true);
      setTimeout(() => window.location.reload(), 150);
    } catch {}
  };

  const submitRating = async () => {
    if (!rating) return;
    setSubmitting(true);
    try {
      await fetch("/api/platform/feedback", {
        method: "POST",
        headers: { ...authHead(), "Content-Type": "application/json" },
        body: JSON.stringify({ rating, comment: rateComment }),
      });
    } finally {
      setSubmitting(false);
      setRateOpen(false);
      setRating(0);
      setRateComment("");
    }
  };

  const submitBug = async () => {
    if (bugText.trim().length < 10) return;
    setSubmitting(true);
    try {
      await fetch("/api/platform/support", {
        method: "POST",
        headers: { ...authHead(), "Content-Type": "application/json" },
        body: JSON.stringify({ message: bugText.trim() }),
      });
    } finally {
      setSubmitting(false);
      setBugOpen(false);
      setBugText("");
    }
  };

  const hasBotAccess = (bot) => {
    if (myBotIds === null) return true;
    if (myBotIds === "all") return true;
    return myBotIds.includes(String(bot._id));
  };

  const handleBotClick = (bot) => {
    if (!hasBotAccess(bot)) {
      // Kilitli bot: o bota özel plan sayfasına yönlendir
      setNoSubBotName(bot.name);
      setNoSubModal(true);
      return;
    }
    navigate("/chat", { state: { botId: bot._id, botName: bot.name } });
    if (isMobile) setOpen(false);
  };

  // "Yapay Zeka Eğitmenler" paneli: tüm botlar + basic (en uygun) paketleri
  const openTrainers = async () => {
    setTrainersOpen(true);
    if (pkgs === null) {
      try {
        const res = await fetch("/api/packages", { headers: authHead() });
        const data = await res.json();
        const list = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
        setPkgs(list.filter(p => p.isActive !== false));
      } catch { setPkgs([]); }
    }
  };

  const basicPkgFor = (bot) => {
    if (!Array.isArray(pkgs)) return null;
    const matches = pkgs.filter(p => (p.name || "").toLowerCase().includes(bot.name.toLowerCase()));
    if (!matches.length) return null;
    // "Basic" paketi tercih et; yoksa en uygun fiyatlıyı göster
    const basics = matches.filter(p => (p.name || "").toLowerCase().includes("basic"));
    const pool = basics.length ? basics : matches;
    return pool.slice().sort((a, b) => (Number(a.price) || 0) - (Number(b.price) || 0))[0];
  };

  const handleTrainerSelect = (bot) => {
    setTrainersOpen(false);
    if (hasBotAccess(bot)) {
      navigate("/chat", { state: { botId: bot._id, botName: bot.name } });
    } else {
      navigate(`/packages?bot=${encodeURIComponent(bot.name)}`);
    }
    if (isMobile) setOpen(false);
  };

  const handleHistoryClick = (session) => {
    navigate("/chat", { state: { chatCode: session.chatCode || session._id, botId: session.bot?._id || session.botId } });
    if (isMobile) setOpen(false);
  };

  const user = (() => { try { return JSON.parse(localStorage.getItem("biyz_user") || "{}"); } catch { return {}; } })();

  const drawerContent = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column",
               background: "linear-gradient(180deg,rgba(20,19,32,0.94),rgba(12,11,16,0.94))", backdropFilter: "blur(18px)", color: "#ECEAF4" }}>
      <Toolbar />
      {/* İlerlemem & Çalışmalarım — kategorili bölümler + grafikler */}
      <Box sx={{ px: 2, pt: 1.5 }}>
        <Box onClick={() => { navigate("/ilerleme"); if (isMobile) setOpen(false); }}
          sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer", borderRadius: 3, p: 1.2,
            background: "linear-gradient(135deg,rgba(79,124,255,0.12),rgba(139,108,255,0.12))",
            border: "1px solid rgba(79,124,255,0.25)", transition: "background 0.15s",
            "&:hover": { background: "rgba(79,124,255,0.2)" } }}>
          <TrendingUpIcon sx={{ color: "#4F7CFF" }} />
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 13.5, fontWeight: 800, color: "#ECEAF4" }}>İlerlemem & Çalışmalarım</Typography>
            <Typography sx={{ fontSize: 11, color: "#9D99B8" }} noWrap>Kelime · Gramer · Alıştırma · Konuşma</Typography>
          </Box>
        </Box>
        {/* Davet + Arkadaşlar (oyunlaştırma) */}
        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
          <Box onClick={() => { navigate("/davet"); if (isMobile) setOpen(false); }}
            sx={{ flex: 1, display: "flex", alignItems: "center", gap: 0.8, cursor: "pointer", borderRadius: 3, p: 1,
              background: "rgba(16,185,129,0.10)", border: "1px solid rgba(16,185,129,0.25)",
              "&:hover": { background: "rgba(16,185,129,0.18)" } }}>
            <CardGiftcardIcon sx={{ color: "#10B981", fontSize: 20 }} />
            <Typography sx={{ fontSize: 12.5, fontWeight: 800, color: "#ECEAF4" }}>Davet Et</Typography>
          </Box>
          <Box onClick={() => { navigate("/arkadaslar"); if (isMobile) setOpen(false); }}
            sx={{ flex: 1, display: "flex", alignItems: "center", gap: 0.8, cursor: "pointer", borderRadius: 3, p: 1,
              background: "rgba(139,108,255,0.10)", border: "1px solid rgba(139,108,255,0.25)",
              "&:hover": { background: "rgba(139,108,255,0.18)" } }}>
            <GroupIcon sx={{ color: "#8B6CFF", fontSize: 20 }} />
            <Typography sx={{ fontSize: 12.5, fontWeight: 800, color: "#ECEAF4" }}>Arkadaşlar</Typography>
          </Box>
        </Box>
      </Box>
      {/* Bildirim + Uygulama kisayollari (Ercan istegi: Davet Et altinda) */}
      <Box sx={{ display: "flex", gap: 1, px: 2, pt: 1 }}>
        {typeof Notification !== "undefined" && !pushOn && !notifDenied && (
          <Box onClick={handleEnablePush} sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 1, cursor: "pointer", borderRadius: 2, px: 1, py: 0.8,
                background: "rgba(139,108,255,0.10)", border: "1px solid rgba(139,108,255,0.35)", "&:hover": { background: "rgba(139,108,255,0.18)" } }}>
            <NotificationsActiveIcon sx={{ color: "#8B6CFF", fontSize: 18 }} />
            <Typography sx={{ fontSize: 12.5, fontWeight: 800, color: "#ECEAF4" }}>Bildirimleri Aç</Typography>
          </Box>
        )}
        {!isStandaloneApp && !pwaInstalled && (
          <Box onClick={handleInstallApp} sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 1, cursor: "pointer", borderRadius: 2, px: 1, py: 0.8,
                background: "rgba(79,124,255,0.10)", border: "1px solid rgba(79,124,255,0.35)", "&:hover": { background: "rgba(79,124,255,0.18)" } }}>
            <GetAppIcon sx={{ color: "#4F7CFF", fontSize: 18 }} />
            <Typography sx={{ fontSize: 12.5, fontWeight: 800, color: "#ECEAF4" }}>Uygulamayı İndir</Typography>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2, pb: 0.5, maxHeight: "252px", overflowY: "auto" }}>
        {/* Tüm eğitmenler + basic paketler paneli */}
        <Box
          onClick={openTrainers}
          sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, cursor: "pointer",
                borderRadius: 2, px: 1, py: 0.5,
                "&:hover": { bgcolor: "rgba(79,124,255,0.10)" },
                transition: "background 0.15s" }}
        >
          <Box component="img" src="/logo192.png?v=b2" alt="bi" sx={{ width: 22, height: 22, borderRadius: "7px", flexShrink: 0 }} />
          <Typography variant="subtitle2" sx={{ color: "#9D99B8", fontWeight: 800, fontSize: 12, letterSpacing: ".05em", textTransform: "uppercase" }}>
            Yapay Zeka Eğitmenler
          </Typography>
        </Box>
        {myBotIds === null && <CircularProgress size={16} sx={{ color: "#4F7CFF" }} />}
        {bots.map(bot => {
          const hasAccess = hasBotAccess(bot);
          return (
            <ListItemButton key={bot._id} onClick={() => handleBotClick(bot)}
              sx={{ borderRadius: 3, mb: 0.25, px: 1.5, py: 0.6,
                    opacity: hasAccess ? 1 : 0.6,
                    "&:hover": { bgcolor: "rgba(255,255,255,0.06)" },
                    "&.Mui-selected, &:active": { bgcolor: "rgba(124,107,255,0.16)" } }}>
              <ListItemIcon sx={{ minWidth: 46 }}>
                <Avatar sx={{
                  width: 36, height: 36, fontSize: 14,
                  background: bot.avatar ? "transparent" : (hasAccess
                    ? "linear-gradient(135deg,#dfe8ff,#efe8ff)"
                    : "rgba(120,140,200,0.12)"),
                  border: bot.avatar ? "1px solid rgba(255,255,255,0.25)" : "1px solid rgba(255,255,255,0.8)",
                }}>
                  {bot.avatar
                    ? <img src={bot.avatar} alt="" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"50%"}} onError={e=>{e.target.style.display="none";}} />
                    : hasAccess ? "🤖" : <LockIcon sx={{ fontSize: 16, color: "rgba(91,107,140,0.7)" }} />}
                </Avatar>
              </ListItemIcon>
              <ListItemText
                primary={bot.name}
                primaryTypographyProps={{ fontSize: 12.5, fontWeight: 600, color: "#ECEAF4" }}
              />
              {!hasAccess && <LockIcon sx={{ fontSize: 14, color: "rgba(91,107,140,0.45)", ml: 0.5 }} />}
            </ListItemButton>
          );
        })}
      </Box>
      <Divider sx={{ borderColor: "rgba(120,140,200,0.16)", mx: 2 }} />
      <Box sx={{ p: 2, pt: 1.5, flexGrow: 1, overflow: "auto" }}>
        <Typography variant="caption" sx={{ color: "#9D99B8", fontWeight: 800, letterSpacing: ".03em", mb: 1, display: "block" }}>
          ÇALIŞMA ALANLARIN
        </Typography>
        {[
          { icon: "📖", label: "Kelime Çalışmaları", sec: "vocabulary" },
          { icon: "📐", label: "Gramer Çalışmaları", sec: "grammar" },
          { icon: "🗣️", label: "Sesli Konuşma Pratikleri", sec: "speaking" },
          { icon: "✍️", label: "Alıştırmalar", sec: "exercise" },
          { icon: "📝", label: "Testler", sec: "test" },
        ].map(cat => (
          <ListItemButton key={cat.sec}
            onClick={() => { navigate("/ilerleme?section=" + cat.sec); if (isMobile) setOpen(false); }}
            sx={{ borderRadius: 2.5, mb: 0.25, px: 1.25, py: 0.5, "&:hover": { bgcolor: "rgba(255,255,255,0.06)" } }}>
            <ListItemIcon sx={{ minWidth: 28, fontSize: 15 }}>{cat.icon}</ListItemIcon>
            <ListItemText primary={cat.label}
              primaryTypographyProps={{ fontSize: 12, fontWeight: 600, color: "#ECEAF4" }} />
          </ListItemButton>
        ))}

        {/* Son sohbetler (resume icin kucuk liste) */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2, mb: 0.5 }}>
          <HistoryIcon sx={{ color: "#9D99B8", fontSize: 15 }} />
          <Typography variant="caption" sx={{ color: "#9D99B8", fontWeight: 700 }}>Son Sohbetler</Typography>
        </Box>
        {history.length === 0 && (
          <Typography variant="caption" sx={{ color: "rgba(154,168,199,0.7)", px: 1 }}>Henüz sohbet yok</Typography>
        )}
        {history.slice(0, 4).map(s => (
          <ListItemButton key={s._id} onClick={() => handleHistoryClick(s)}
            sx={{ borderRadius: 3, mb: 0.5, px: 1.5, py: 0.6, "&:hover": { bgcolor: "rgba(255,255,255,0.06)" } }}>
            <ListItemIcon sx={{ minWidth: 28 }}><HistoryIcon sx={{ color: "#9D99B8", fontSize: 14 }} /></ListItemIcon>
            <ListItemText
              primary={s.bot?.name ? (s.title && s.title !== "Yeni Oturum" ? `${s.bot.name}: ${s.title}` : s.bot.name) : (s.title && s.title !== "Yeni Oturum" ? s.title : (s.chatCode || s._id?.toString().slice(-8)))}
              primaryTypographyProps={{ fontSize: 11.5, color: "#9D99B8", noWrap: true }} />
          </ListItemButton>
        ))}
      </Box>
      <Dialog open={installInfo} onClose={() => setInstallInfo(false)}>
        <DialogTitle>Uygulamayı İndir</DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: 14, mb: 1 }}>Tek tık kurulum penceresi bu cihazda şu an açılamıyor — <b>büyük ihtimalle uygulama zaten kurulu</b>. Adres çubuğundaki <b>"Uygulamada aç"</b> düğmesiyle uygulamayı başlatabilirsin.</Typography>
          <Typography sx={{ fontSize: 13.5, lineHeight: 1.7 }}>
            • <b>Chrome / Edge:</b> adres çubuğundaki kur simgesi veya menü → "Yükle".<br />
            • <b>iPhone / iPad:</b> Paylaş → "Ana Ekrana Ekle".<br />
            • <b>Android:</b> tarayıcı menüsü → "Uygulamayı yükle".
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color="success" onClick={() => { try { localStorage.setItem("biyz_pwa_installed", "1"); } catch {} setInstallInfo(false); setTimeout(() => window.location.reload(), 150); }}>✓ Zaten Yükledim</Button>
          <Button variant="contained" onClick={() => setInstallInfo(false)}>Tamam</Button>
        </DialogActions>
      </Dialog>
      <Divider sx={{ borderColor: "rgba(120,140,200,0.16)" }} />
      <ListItemButton onClick={handleLogout} sx={{ m: 1, borderRadius: 3 }}>
        <ListItemIcon sx={{ minWidth: 36 }}><LogoutIcon sx={{ color: "#9D99B8", fontSize: 18 }} /></ListItemIcon>
        <ListItemText primary="Çıkış Yap" primaryTypographyProps={{ fontSize: 13, color: "#9D99B8" }} />
      </ListItemButton>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", minHeight: "100vh",
               background: "linear-gradient(135deg,#0C0B10 0%,#141320 100%)",
               position: "relative",
               "&::before": {
                 content: '""', position: "fixed", inset: 0, zIndex: 0, pointerEvents: "none",
                 background: "radial-gradient(680px 460px at 12% 4%,rgba(124,107,255,.22),transparent 62%),radial-gradient(620px 460px at 88% 8%,rgba(63,208,198,.10),transparent 60%),radial-gradient(640px 520px at 70% 100%,rgba(124,107,255,.14),transparent 62%)",
               } }}>
      <CssBaseline />

      <AppBar position="fixed" elevation={0}
        sx={{ zIndex: theme.zIndex.drawer + 1,
              background: "linear-gradient(90deg,#141320 0%,#0C0B10 100%)",
              borderBottom: "1px solid rgba(231,199,123,.25)",
              color: "#ffffff" }}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={() => setOpen(!open)} sx={{ mr: 1 }}>
            <MenuIcon />
          </IconButton>
          {/* Geri / Ana sayfa — ana sayfa dışındaki tüm sayfalarda görünür */}
          {!onHome && (
            <>
              <IconButton color="inherit" sx={{ mr: 0.5 }}
                title="Geri"
                onClick={() => (window.history.length > 2 ? navigate(-1) : navigate("/chat"))}>
                <ArrowBackIcon />
              </IconButton>
              <IconButton color="inherit" sx={{ mr: 1 }}
                title="Ana Sayfa"
                onClick={() => navigate("/chat")}>
                <HomeIcon />
              </IconButton>
            </>
          )}
          {/* Logo — biYAPAYZEKA (Noir Luxe lockup: mor squircle + mor->turkuaz gradyan yazi) */}
          <Box onClick={() => navigate("/chat")} sx={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer", mr: 1.5, flexShrink: 0, userSelect: "none" }}>
            <Box sx={{ width: 40, height: 40, borderRadius: "13px", background: "linear-gradient(135deg,#9E86FB,#7C5CFC)", display: "grid", placeItems: "center", color: "#fff", fontWeight: 800, fontSize: 18, lineHeight: 1, boxShadow: "0 4px 14px rgba(124,92,252,.42)", fontFamily: "system-ui,'Segoe UI',sans-serif" }}>bi</Box>
            <Box component="span" sx={{ fontSize: 20, fontWeight: 800, letterSpacing: "-.02em", color: "#fff", fontFamily: "system-ui,'Segoe UI',sans-serif", lineHeight: 1, whiteSpace: "nowrap" }}>
              bi<Box component="span" sx={{ background: "linear-gradient(90deg,#7C5CFC,#3B6BFF)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>YAPAYZEKA</Box>
            </Box>
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            {/* Oyunlastirma rozeti: gunluk seri (🔥) + bugunku XP (⚡) — Duolingo tarzi */}
            {gami && (
              <Box
                onClick={() => navigate("/ilerleme")}
                title={`Gunluk seri: ${gami.streakCount || 0} gun  •  Bugun: ${gami.xpToday || 0}/${gami.dailyGoalXp || 30} XP`}
                sx={{ display: "inline-flex", alignItems: "center", gap: 1, cursor: "pointer",
                      px: 1.3, py: 0.5, borderRadius: 999,
                      background: "rgba(255,255,255,.10)", border: "1px solid rgba(255,255,255,.22)",
                      backdropFilter: "blur(4px)" }}>
                <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.4, fontWeight: 800, fontSize: 13, color: "#FFB74D" }}>
                  <span style={{ fontSize: 15, lineHeight: 1 }}>🔥</span>{gami.streakCount || 0}
                </Box>
                <Box component="span" sx={{ width: "1px", height: 14, background: "rgba(255,255,255,.25)" }} />
                <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.4, fontWeight: 800, fontSize: 13, color: "#FFD54F" }}>
                  <span style={{ fontSize: 14, lineHeight: 1 }}>⚡</span>{gami.xpToday || 0}
                </Box>
              </Box>
            )}
            <Box sx={{ px: 1.7, py: 0.5, borderRadius: 999, display: { xs: "none", sm: "inline-flex" }, alignItems: "center", gap: 0.6,
                       background: "linear-gradient(135deg,#FBEFC0 0%,#E8CF8A 45%,#C9A961 100%)", color: "#0A2A5E",
                       fontSize: 12, fontWeight: 800, letterSpacing: ".08em",
                       border: "1px solid rgba(255,255,255,.45)",
                       boxShadow: "0 2px 12px rgba(201,169,97,.55), inset 0 1px 0 rgba(255,255,255,.7)" }}>
              <Box component="span" sx={{ fontSize: 13, lineHeight: 1 }}>👑</Box>
              ELİT ÜYE
            </Box>
            <Box sx={{ display: { xs: "none", sm: "flex" }, flexDirection: "column", alignItems: "flex-end", lineHeight: 1.12 }}>
              <Typography variant="body2" sx={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>
                {user.fullName || user.name || user.username || "Kullanıcı"}
              </Typography>
            </Box>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ p: 0.5 }}>
              <Avatar
                src={me?.avatar || user.avatar || undefined}
                imgProps={{ referrerPolicy: "no-referrer" }}
                sx={{ width: 38, height: 38, background: "linear-gradient(135deg,#E8CF8A,#C9A961)", color: "#0A2A5E", fontSize: 14, fontWeight: 800 }}>
                {(user.fullName || user.name || user.username || "U")[0].toUpperCase()}
              </Avatar>
            </IconButton>
            <ArrowDropDownIcon sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer" }}
              onClick={(e) => setAnchorEl(e.currentTarget)} />
          </Box>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            <MenuItem onClick={() => { setAnchorEl(null); navigate("/packages?upgrade=1"); }}>
              <UpgradeIcon sx={{ mr: 1 }} /> Planı Yükselt
            </MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); navigate("/settings"); }}>
              <SettingsIcon sx={{ mr: 1 }} /> Profil Ayarları
            </MenuItem>
            <MenuItem onClick={(e) => { setHelpAnchorEl(e.currentTarget); }}>
              <HelpOutlineIcon sx={{ mr: 1 }} /> Yardim Merkezi
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <LogoutIcon sx={{ mr: 1 }} /> Oturumu Kapat
            </MenuItem>
          </Menu>
          <Menu anchorEl={helpAnchorEl} open={Boolean(helpAnchorEl)}
            onClose={() => setHelpAnchorEl(null)}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}>
            <MenuItem onClick={() => { setHelpAnchorEl(null); setAnchorEl(null); setRating(0); setRateComment(""); setRateOpen(true); }}>
              <StarIcon sx={{ mr: 1, color: "#f59e0b" }} /> Bizi Degerlendirin
            </MenuItem>
            <MenuItem onClick={() => { setHelpAnchorEl(null); setAnchorEl(null); navigate("/support"); }}>
              <ConfirmationNumberIcon sx={{ mr: 1, color: "#1565c0" }} /> Destek Biletlerim
            </MenuItem>
            <MenuItem onClick={() => { setHelpAnchorEl(null); setAnchorEl(null); setBugText(""); setBugOpen(true); }}>
              <BugReportIcon sx={{ mr: 1, color: "#dc2626" }} /> Sorun Bildir
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Drawer variant={isMobile ? "temporary" : "persistent"} open={open}
        onClose={() => setOpen(false)} ModalProps={{ keepMounted: true }}
        sx={{ width: (!isMobile && open) ? drawerWidth : 0, flexShrink: 0,
              transition: theme.transitions.create("width", { duration: theme.transitions.duration.leavingScreen }),
              "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box",
              border: "none", borderRight: "1px solid rgba(120,140,200,.16)", backgroundColor: "transparent" } }}>
        {drawerContent}
      </Drawer>

      <Box component="main" sx={{
        // Chat sayfası kendi içinde scroll yönetir; diğer sayfalar dikey kaydırılabilir
        // NOT: persistent Drawer zaten yer kaplıyor (in-flow) — main'e AYRICA ml verince
        // içerik 2× sağa kayıyordu (ortalanmama bug'ı). ml kaldırıldı, minWidth:0 ile taşma engellendi.
        flexGrow: 1, minWidth: 0, pt: "64px", overflow: onHome ? "hidden" : "auto",
        height: "100vh", display: "flex", flexDirection: "column",
        background: "transparent", position: "relative", zIndex: 1,
      }}>
        {children}
      </Box>

      {/* KVKK */}
      <Dialog open={kvkk} disableEscapeKeyDown>
        <DialogTitle>KVKK Aydınlatma Metni</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            BIYapayZeka olarak kişisel verilerinizi 6698 sayılı KVKK kapsamında işlemekteyiz.
            Verileriniz yalnızca hizmet sunumu amacıyla kullanılmaktadır.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => { localStorage.setItem("kvkk_ok","1"); setKvkk(false); putMe({ kvkkAccepted: true }); }}>
            Okudum, Kabul Ediyorum
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bildirim izni */}
      <Dialog open={!kvkk && notif}>
        <DialogTitle>Bildirimler</DialogTitle>
        <DialogContent>
          <Typography variant="body2">Özel kampanya ve güncellemelerden haberdar olmak ister misiniz?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { localStorage.setItem("notif_asked","0"); setNotif(false); putMe({ notifAsked: true, reminderOptIn: false }); }}>Hayır</Button>
          <Button variant="contained" onClick={() => { localStorage.setItem("notif_asked","1"); setNotif(false); putMe({ notifAsked: true, reminderOptIn: true }); if (window.biPushSubscribe) window.biPushSubscribe(); }}>Evet</Button>
        </DialogActions>
      </Dialog>

      {/* Erişim Gerekli modal — kilitli bot için o bota özel planlara yönlendirme */}
      <Dialog open={noSubModal} onClose={() => setNoSubModal(false)}>
        <DialogTitle sx={{ textAlign: "center", pt: 3 }}>Erişim Gerekli</DialogTitle>
        <DialogContent sx={{ textAlign: "center", px: 4 }}>
          <Typography variant="body2">
            {noSubBotName
              ? `${noSubBotName} yapay zeka eğitmenine erişmek için uygun bir plan gerekiyor.`
              : "Bu yapay zeka eğitmenini kullanmak için uygun bir plana sahip değilsiniz."}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3, flexDirection: "column", gap: 1 }}>
          <Button variant="contained" fullWidth
            sx={{ background: "linear-gradient(135deg,#4F7CFF,#8B6CFF)", borderRadius: 2, textTransform: "none", fontWeight: 700 }}
            onClick={() => {
              setNoSubModal(false);
              // O bota özel planları göster
              if (noSubBotName) {
                navigate(`/packages?bot=${encodeURIComponent(noSubBotName)}`);
              } else {
                navigate("/packages");
              }
            }}>
            {noSubBotName ? `${noSubBotName} planlarını gör` : "Planları görüntüle"}
          </Button>
          <Button onClick={() => setNoSubModal(false)} sx={{ color: "text.secondary" }}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      <OnboardingModal me={me} />
      <PWAInstallBanner />

      {/* Yapay Zeka Eğitmenler — tüm botlar + basic paketleri */}
      <Dialog open={trainersOpen} onClose={() => setTrainersOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SmartToyIcon sx={{ color: "#1565c0" }} />
          Yapay Zeka Eğitmenler
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Bir eğitmen seçin — erişiminiz varsa sohbete, yoksa o eğitmenin planlarına yönlendirilirsiniz.
          </Typography>
          {pkgs === null && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
              <CircularProgress size={28} />
            </Box>
          )}
          <Grid container spacing={1.5}>
            {bots.map(bot => {
              const hasAccess = hasBotAccess(bot);
              const basic = basicPkgFor(bot);
              return (
                <Grid item xs={12} sm={6} md={4} key={bot._id}>
                  <Box
                    onClick={() => handleTrainerSelect(bot)}
                    sx={{
                      border: "1.5px solid #e0e0e0", borderRadius: 2, p: 1.5,
                      cursor: "pointer", display: "flex", alignItems: "center", gap: 1.5,
                      transition: "all 0.15s",
                      "&:hover": { borderColor: "#1565c0", boxShadow: 2, bgcolor: "#f5faff" },
                    }}>
                    <Avatar sx={{
                      width: 40, height: 40, fontSize: 15, flexShrink: 0,
                      background: bot.avatar ? "transparent" : "linear-gradient(135deg,#6c3de0,#2196f3,#00bcd4)",
                    }}>
                      {bot.avatar
                        ? <img src={bot.avatar} alt="" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"50%"}} onError={e=>{e.target.style.display="none";}} />
                        : "🤖"}
                    </Avatar>
                    <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                      <Typography variant="body2" fontWeight={600} noWrap>{bot.name}</Typography>
                      {pkgs !== null && (
                        basic
                          ? <Chip size="small" label={Number(basic.price) > 0 ? `Basic — ${basic.price} TL` : "Ücretsiz plan"}
                              sx={{ mt: 0.5, height: 20, fontSize: 11, bgcolor: "#e3f2fd", color: "#1565c0", fontWeight: 600 }} />
                          : <Chip size="small" label="Planları gör"
                              sx={{ mt: 0.5, height: 20, fontSize: 11, bgcolor: "#f5f5f5", color: "#757575" }} />
                      )}
                    </Box>
                    {!hasAccess && <LockIcon sx={{ fontSize: 16, color: "#bdbdbd", flexShrink: 0 }} />}
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTrainersOpen(false)}>Kapat</Button>
        </DialogActions>
      </Dialog>

      {/* Bizi Degerlendirin modal */}
      <Dialog open={rateOpen} onClose={() => setRateOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ pb: 1 }}>
          Geri bildirimin bizim icin cok degerli
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>Genel deneyimini kisaca puanlar misin?</Typography>
          <Rating value={rating} onChange={(_, v) => setRating(v)} size="large" sx={{ mb: 2 }} />
          <Box
            component="textarea"
            value={rateComment}
            onChange={e => setRateComment(e.target.value.slice(0, 500))}
            placeholder="Yorum (opsiyonel)"
            rows={4}
            sx={{
              width: "100%", boxSizing: "border-box", resize: "vertical",
              border: "1px solid #ccc", borderRadius: 1, p: 1.5,
              fontFamily: "inherit", fontSize: 14,
            }}
          />
          <Typography variant="caption" color="text.secondary">{rateComment.length}/500</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRateOpen(false)}>IPTAL</Button>
          <Button variant="contained" onClick={submitRating} disabled={!rating || submitting}>
            {submitting ? <CircularProgress size={18} /> : "GONDER"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Sorun Bildir modal */}
      <Dialog open={bugOpen} onClose={() => setBugOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Sorun Bildir</DialogTitle>
        <DialogContent>
          <Box
            component="textarea"
            value={bugText}
            onChange={e => setBugText(e.target.value)}
            placeholder="Sorununuzu anlatın"
            rows={6}
            sx={{
              width: "100%", boxSizing: "border-box", resize: "vertical",
              border: "1px solid #ccc", borderRadius: 1, p: 1.5, mt: 1,
              fontFamily: "inherit", fontSize: 14,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBugOpen(false)}>IPTAL</Button>
          <Button variant="contained" onClick={submitBug}
            disabled={bugText.trim().length < 10 || submitting}>
            {submitting ? <CircularProgress size={18} /> : "GONDER"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
